export const getRandomInteger = (min = 0, max = 99999999) => Math.floor(Math.random() * (max - min + 1)) + min;
export const percent = (correct, total) => {
  const validTotal = total || correct || 1;
  return `${Math.round(correct / validTotal * 100)}%`;
};